module.exports = __webpack_public_path__ + "img/icon_full_pt_shadow.77ee2105.png";